import { Link } from "@inertiajs/react";
import { Plus } from "lucide-react";
import { AWARD_STYLES } from "@/lib/prizes";

/** The two student-prize styles beyond "everyone who reaches it". */
export default function OtherWaysToReward({ studentPrizesPath, onAdd }) {
  const TopIcon = AWARD_STYLES.top_in_class.icon;
  const DrawIcon = AWARD_STYLES.raffle.icon;

  return (
    <div className="rounded-xl border border-border p-5 text-left text-sm">
      <p className="font-medium text-foreground">Other ways to reward readers</p>
      <ul className="mt-2 space-y-2 text-muted-foreground">
        <li className="flex gap-2">
          <TopIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
          <span><strong className="font-medium text-foreground">Top student</strong> — the student who reads the most (or raises the most) in each class, each division or the whole school wins. Ties all win.</span>
        </li>
        <li className="flex gap-2">
          <DrawIcon className="mt-0.5 h-4 w-4 shrink-0 text-accent" aria-hidden="true" />
          <span><strong className="font-medium text-foreground">Prize draw</strong> — every so many minutes earns an entry, and you draw winners after reading ends, for the whole school or in each division.</span>
        </li>
      </ul>
      {studentPrizesPath && (
        <Link href={studentPrizesPath} className="mt-3 inline-flex items-center gap-1 font-medium text-primary hover:underline">
          <Plus className="h-3.5 w-3.5" />
          Set these up on the Student prizes page
        </Link>
      )}
      {onAdd && (
        <button type="button" onClick={onAdd} className="mt-3 inline-flex items-center gap-1 font-medium text-primary hover:underline">
          <Plus className="h-3.5 w-3.5" />
          Add a prize of your own
        </button>
      )}
    </div>
  );
}
